import * as React from 'react'

import { MobXProviderContext } from 'mobx-react'

import type { LocationResource } from '~/client/src/shared/resources/domain/locationResource'
import type { LocationResourceDomainFailure } from '~/client/src/shared/resources/domain/locationResourceTypeDefinition'
import { requireLocationResourceSuccess } from '~/client/src/shared/resources/presentation/requireLocationResourceSuccess'
import type ProjectResourcesStore from '~/client/src/shared/stores/domain/ProjectResources.store'
import type InitialState from '~/client/src/shared/stores/InitialState'

import {
  ProjectResourceStoreView,
  useProjectResourceStore,
} from './useProjectResourceStore'

type LocationResourcesStore = ProjectResourcesStore<
  LocationResource,
  LocationResourceDomainFailure
>

interface LocationResourceStoreContext {
  readonly locationResourcesStore: LocationResourcesStore
}

export type LocationResourceStoreView = ProjectResourceStoreView<
  LocationResource,
  LocationResourceDomainFailure
>

export function useLocationResourceStore(
  projectId?: string,
): LocationResourceStoreView {
  const { locationResourcesStore } = React.useContext(
    MobXProviderContext,
  ) as LocationResourceStoreContext

  return useProjectResourceStore(
    projectId,
    locationResourcesStore,
    requireLocationResourceSuccess,
  )
}

/** The project a location hook reads: the given one, else the active one; none without a store to read it from. Call from an observer. */
export function useLocationProjectId(projectId?: string): string | undefined {
  const { state, locationResourcesStore } = React.useContext(
    MobXProviderContext,
  ) as { state?: InitialState; locationResourcesStore?: object }

  return locationResourcesStore
    ? (projectId ?? state?.activeProject?.id) || undefined
    : undefined
}
